import React, { useCallback, useMemo, useState } from "react";
import PartnerRow from "./PartnerRow";
import { usePartnersStore } from "../../stores/partnersStore";
import { useAuth } from "hooks/useAuth";
import { ImageModal } from "components";

// Компонент для відображення таблиці продукції партнерів
const PartnersTable = React.memo(() => {
  // Отримуємо дані та дії зі стору
  const partners = usePartnersStore((state) => state.partners);
  const sort_by = usePartnersStore((state) => state.filters.sort_by);
  const sort_asc = usePartnersStore((state) => state.filters.sort_asc);
  const setSort = usePartnersStore((state) => state.setSort);
  const updatePartnerProperty = usePartnersStore(
    (state) => state.updatePartnerProperty,
  );
  const deletePartnerProperty = usePartnersStore(
    (state) => state.deletePartnerProperty,
  );

  // Отримуємо функцію для перевірки прав доступу
  const { isAllowed } = useAuth();

  // Динамічно формуємо заголовки таблиці
  const headers = useMemo(() => {
    // Базові заголовки, видимі для всіх
    const baseHeaders = [
      { label: "Фото", field: null },
      { label: "Артикул", field: "article" },
      { label: "Назва / модель", field: "name" },
      { label: "Тип ціни", field: "property_id" },
      { label: "Ціна", field: "price" },
      { label: "Наявність", field: "availability" },
    ];

    // Якщо у користувача є права, додаємо колонку "Дії"
    if (isAllowed("partners:edit") || isAllowed("partners:delete")) {
      baseHeaders.push({ label: "Дії", field: null });
    }

    return baseHeaders;
  }, [isAllowed]);

  // Стан для відображення зображення в модальному вікні
  const [selectedImage, setSelectedImage] = useState(null);

  // Обробник кліку по мініатюрі зображення
  const handleImageClick = useCallback((imgUrl) => {
    if (!imgUrl) return;
    setSelectedImage(imgUrl);
  }, []);

  // Закриття модального вікна зображення
  const closeImageModal = useCallback(() => {
    setSelectedImage(null);
  }, []);

  return (
    <>
      <table id="partner-table">
        <thead>
          <tr>
            {headers.map(({ label, field }) => (
              <th
                key={field || label}
                className={field ? "clickable" : ""}
                onClick={field ? () => setSort(field) : undefined}
              >
                {label}
                {field === sort_by && (sort_asc ? " ▲" : " ▼")}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {partners.length === 0 ? (
            <tr>
              <td colSpan={headers.length} className="empty-row">
                Немає даних товарів партнерів
              </td>
            </tr>
          ) : (
            partners.map((partner) => (
              <PartnerRow
                key={partner.article}
                item={partner}
                onImageClick={handleImageClick}
                onUpdate={updatePartnerProperty}
                onDelete={deletePartnerProperty}
              />
            ))
          )}
        </tbody>
      </table>
      <ImageModal
        isOpen={!!selectedImage}
        src={selectedImage}
        alt="Enlarged"
        onClose={closeImageModal}
      />
    </>
  );
});

export default PartnersTable;
